@if (!hasError) {
  <div class="main-container" data-cy="token-handler-normal">
    <h2 data-cy="token-handler-title">Importing information from TDO 12</h2>
    <div class="spinner-container" data-cy="token-handler-spinner-container">
      <mat-spinner data-cy="token-handler-spinner"></mat-spinner>
    </div>
  </div>
}
@if (hasError) {
  <div class="main-container" data-cy="token-handler-error">
    <h2 class="warning" data-cy="token-handler-error-message">TDO has encountered an error. Redirecting to the home page</h2>
  </div>
}
